// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/slotsbg-02.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/happy-goose.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/public/slotreel4.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/public/goose.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --icon-width: 79px;
  --icon-height: 79px;
  --num-icons: 14;
  --slots-padding: 20px;
}

.joe-logo {
  display: flex;
  align-self: center;
  width: 90%;
}
.slot-machine-container {
  justify-content: space-between;
  background-color: #141414;
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;
  width: 100vw;
  max-width: 500px;
  height: 100vh;
  padding: 10px;
}

.slots {
  width: 100%;
  height: 100%;
  position: relative;
  padding: var(--slots-padding);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.6rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
}

/* .slots::after,
.slots::before {
  content: "";
  position: absolute;
  top: 50%;
  width: 25px;
  height: 4px;
  background-color: rgba(7, 7, 7, 0.767);
} */

.slots::after {
  z-index: 1;
  left: 0px;
}
.slots::before {
  z-index: 1;
  right: 0px;
}

@keyframes win1 {
  0% {
    /* background: linear-gradient(
      45deg,
      rgb(140, 0, 255) 0%,
      rgb(185, 20, 207) 100%
    ); */
    box-shadow: 0 0 80px rgb(182, 93, 255);
  }
  100% {
    /* background: linear-gradient(
      45deg,
      rgb(71, 71, 71) 0%,
      rgb(44, 44, 44) 100%
    ); */
    box-shadow: 0 0 80px rgba(111, 0, 255, 0);
  }
}

@keyframes win2 {
  0% {
    /* background: linear-gradient(45deg, lightblue 0%, lightgreen 100%); */
    box-shadow: 0 0 80px rgb(151, 76, 221);
  }
  100% {
    /* background: linear-gradient(45deg, grey 0%, lightgrey 100%); */
    box-shadow: -2px 2px 3px rgba(0, 0, 0, 0.3);
  }
}

.win1 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) !important;
  animation: win1 200ms steps(2, end) infinite;
}

.win2 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) !important;
  animation: win2 200ms steps(2, end) infinite;
}

.reel {
  position: relative;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  outline: 3px solid black;
  background: rgb(214, 214, 214);
  width: var(--icon-width);
  height: calc(3 * var(--icon-height));
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-position: 0 0;
  background-repeat: repeat-y;
}

.reel::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: linear-gradient(
    rgba(0, 0, 0, 0.5) 0%,
    transparent 20%,
    transparent 80%,
    rgba(0, 0, 0, 0.5) 100%
  );
}

.debug {
  width: 100%;
  height: 130px;
  max-height: 130px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-position: right bottom;
  background-repeat: no-repeat;
  background-size: contain;
  background-color: #1d1d1d;
  font-weight: 400;
  font-size: 14px;
  color: rgb(207, 134, 255);
  padding: 0.8rem;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  /* box-shadow: inset 0px -5px 7px -1px rgba(0, 0, 0, 0.4),
    inset 0px -12px 54px -7px rgba(0, 0, 0, 0.2),
    inset 0px 25px 54px -7px rgba(0, 0, 0, 0.2),
    inset 0px 25px 15px -1px rgba(238, 238, 238, 0.24); */
}

.debug-text {
  max-width: 70%;
  text-shadow: 0 0 5px #ebccff7e, 0 0 25px #ffffff83;
  font-family: "Press Start 2P", system-ui;
  line-height: 1rem;
  text-align: center;
  word-spacing: -0.4rem;
}

.control-panel {
  width: 97vw;
  height: 28vh;
  max-width: 500px;
  position: absolute;
  bottom: 0;
  align-items: center;
  display: flex;
  gap: 8px;
  flex-direction: column;
  justify-content: flex-end;
  padding: 12px;
  background-color: #1d1d1d;
  border-radius: 20px;
}

.b-settings-container {
  display: flex;
  width: 100%;
  height: 30%;
  justify-content: space-between;
  gap: 8px;
}

.b-settings {
  font-family: "Press Start 2P", system-ui;
  width: 80%;
  height: 100%;
  font-weight: 600;
  overflow: hidden;
  color: #a24ce9b7;
  background-color: rgb(238, 238, 238);
  box-shadow: inset 0px -10px 2px 0 rgba(44, 71, 160, 0.267);

  border-radius: 8px;
}

.b-color-multiplyer {
  color: rgba(162, 76, 233, 0.719);
  background-color: rgb(238, 238, 238);
  /* box-shadow: 0px 5px 5px 0 rgba(0, 0, 0, 0.2),
    inset 0px -10px 2px 0 rgba(44, 71, 160, 0.267); */
}

.counters {
  width: 100%;
  height: 40%;
  display: flex;
  flex-direction: column;
}

.counter-heading-text {
  font-family: "Press Start 2P", system-ui;
  font-size: 12px;
  transform: translateY(2px);
}
.counter-container {
  position: relative;
  display: flex;
  align-items: center;
  display: flex;
  padding: 0.3rem;
  background: linear-gradient(
    180deg,
    rgb(192, 192, 192) 10%,
    rgb(87, 87, 87) 95%,
    rgb(61, 61, 61) 100%
  );
  border-radius: 8px;
  width: 100%;
  height: 50%;
}

.counter-heading {
  background-color: rgb(178, 134, 219);
  border-bottom: rgba(255, 255, 255, 0.404) 2px solid;
  /* box-shadow: inset 0px 0px 12px 2px rgba(0, 0, 0, 0.4); */
  font-size: 14px;
  font-weight: 600;
  color: rgba(3, 3, 3, 0.842);
  padding: 0.3rem;
  width: 30%;
  height: 100%;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 0.5rem;
  white-space: nowrap;
  transition: text 0.2s ease;
}

.counter-heading-have {
  background-color: rgb(221, 170, 29);
}

.counter-text {
  display: flex;
  align-items: center;
  width: 70%;
  height: 100%;
  background-color: rgb(49, 49, 49);
  border-bottom: rgba(255, 255, 255, 0.404) 2px solid;
  font-weight: 600;
  color: rgb(227, 221, 230);
  padding: 0.3rem 0.6rem;
  border-radius: 5px;
  /* box-shadow: inset 0px 6px 12px 2px rgba(0, 0, 0, 0.411); */
}

.b-roll {
  font-family: "Press Start 2P", system-ui;
  width: 100%;
  height: 30%;
  font-weight: 600;
  overflow: hidden;
  color: rgba(0, 0, 0, 0.719);
  font-size: 18px;
  border-radius: 8px;
  background-color: #a771ff;
  box-shadow: inset 0px -10px 2px 0 rgba(44, 71, 160, 0.267);
}

.b-combinations {
  background-color: rgb(88, 88, 88);
  height: 35px;
  width: 35px;
  font-size: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  font-weight: 500;
  color: black;
  padding: 10px;
  position: absolute;
  right: 10px;
}

.bg-combs {
  position: absolute;
  z-index: 2;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: end;
}

.win-circle {
  position: absolute;
  z-index: 10;
  width: 105%;
  aspect-ratio: 1/1;
  opacity: 0;
  border-radius: 12px;
  border: 5px solid #ffffff;
  animation: showCircle 2s ease;
}

@keyframes showCircle {
  0% {
    opacity: 0;
    scale: 1.5;
  }
  10% {
    opacity: 1;
    scale: 1;
  }
  90% {
    opacity: 1;
    scale: 1;
  }
  100% {
    opacity: 0;
    scale: 1.5;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Casino/SlotMachine.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,yDAA8C;EAC9C,sBAAsB;EACtB,2BAA2B;EAC3B,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;;;;;;;;GAQG;;AAEH;EACE,UAAU;EACV,SAAS;AACX;AACA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE;IACE;;;;QAII;IACJ,sCAAsC;EACxC;EACA;IACE;;;;QAII;IACJ,yCAAyC;EAC3C;AACF;;AAEA;EACE;IACE,uEAAuE;IACvE,sCAAsC;EACxC;EACA;IACE,iEAAiE;IACjE,2CAA2C;EAC7C;AACF;;AAEA;EACE,oEAA0D;EAC1D,4CAA4C;AAC9C;;AAEA;EACE,oEAA0D;EAC1D,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;EACxB,8BAA8B;EAC9B,wBAAwB;EACxB,oCAAoC;EACpC,yDAA6C;EAC7C,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ;;;;;GAKC;AACH;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yDAAyC;EACzC,iCAAiC;EACjC,4BAA4B;EAC5B,wBAAwB;EACxB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,4BAA4B;EAC5B,6BAA6B;EAC7B;;;yDAGuD;AACzD;;AAEA;EACE,cAAc;EACd,kDAAkD;EAClD,wCAAwC;EACxC,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,QAAQ;EACR,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,WAAW;EACX,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,wCAAwC;EACxC,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,oCAAoC;EACpC,0DAA0D;;EAE1D,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;EACpC;qDACmD;AACrD;;AAEA;EACE,WAAW;EACX,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf;;;;;GAKC;EACD,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,mDAAmD;EACnD,2DAA2D;EAC3D,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;EACf,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,iCAAiC;EACjC,mDAAmD;EACnD,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,6DAA6D;AAC/D;;AAEA;EACE,wCAAwC;EACxC,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,0DAA0D;AAC5D;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,WAAW;EACX,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,OAAO;EACP,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,UAAU;EACV,mBAAmB;EACnB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE;IACE,UAAU;IACV,UAAU;EACZ;EACA;IACE,UAAU;IACV,QAAQ;EACV;EACA;IACE,UAAU;IACV,QAAQ;EACV;EACA;IACE,UAAU;IACV,UAAU;EACZ;AACF","sourcesContent":[":root {\r\n  --icon-width: 79px;\r\n  --icon-height: 79px;\r\n  --num-icons: 14;\r\n  --slots-padding: 20px;\r\n}\r\n\r\n.joe-logo {\r\n  display: flex;\r\n  align-self: center;\r\n  width: 90%;\r\n}\r\n.slot-machine-container {\r\n  justify-content: space-between;\r\n  background-color: #141414;\r\n  display: flex;\r\n  align-items: center;\r\n  flex-direction: column;\r\n  text-align: center;\r\n  width: 100vw;\r\n  max-width: 500px;\r\n  height: 100vh;\r\n  padding: 10px;\r\n}\r\n\r\n.slots {\r\n  width: 100%;\r\n  height: 100%;\r\n  position: relative;\r\n  padding: var(--slots-padding);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 0.6rem;\r\n  background-image: url(/public/slotsbg-02.webp);\r\n  background-size: cover;\r\n  background-position: center;\r\n  border-bottom-left-radius: 20px;\r\n  border-bottom-right-radius: 20px;\r\n}\r\n\r\n/* .slots::after,\r\n.slots::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 50%;\r\n  width: 25px;\r\n  height: 4px;\r\n  background-color: rgba(7, 7, 7, 0.767);\r\n} */\r\n\r\n.slots::after {\r\n  z-index: 1;\r\n  left: 0px;\r\n}\r\n.slots::before {\r\n  z-index: 1;\r\n  right: 0px;\r\n}\r\n\r\n@keyframes win1 {\r\n  0% {\r\n    /* background: linear-gradient(\r\n      45deg,\r\n      rgb(140, 0, 255) 0%,\r\n      rgb(185, 20, 207) 100%\r\n    ); */\r\n    box-shadow: 0 0 80px rgb(182, 93, 255);\r\n  }\r\n  100% {\r\n    /* background: linear-gradient(\r\n      45deg,\r\n      rgb(71, 71, 71) 0%,\r\n      rgb(44, 44, 44) 100%\r\n    ); */\r\n    box-shadow: 0 0 80px rgba(111, 0, 255, 0);\r\n  }\r\n}\r\n\r\n@keyframes win2 {\r\n  0% {\r\n    /* background: linear-gradient(45deg, lightblue 0%, lightgreen 100%); */\r\n    box-shadow: 0 0 80px rgb(151, 76, 221);\r\n  }\r\n  100% {\r\n    /* background: linear-gradient(45deg, grey 0%, lightgrey 100%); */\r\n    box-shadow: -2px 2px 3px rgba(0, 0, 0, 0.3);\r\n  }\r\n}\r\n\r\n.win1 {\r\n  background-image: url(/public/happy-goose.webp) !important;\r\n  animation: win1 200ms steps(2, end) infinite;\r\n}\r\n\r\n.win2 {\r\n  background-image: url(/public/happy-goose.webp) !important;\r\n  animation: win2 200ms steps(2, end) infinite;\r\n}\r\n\r\n.reel {\r\n  position: relative;\r\n  border-radius: 4px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  outline: 3px solid black;\r\n  background: rgb(214, 214, 214);\r\n  width: var(--icon-width);\r\n  height: calc(3 * var(--icon-height));\r\n  background-image: url(/public/slotreel4.webp);\r\n  background-position: 0 0;\r\n  background-repeat: repeat-y;\r\n}\r\n\r\n.reel::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-image: linear-gradient(\r\n    rgba(0, 0, 0, 0.5) 0%,\r\n    transparent 20%,\r\n    transparent 80%,\r\n    rgba(0, 0, 0, 0.5) 100%\r\n  );\r\n}\r\n\r\n.debug {\r\n  width: 100%;\r\n  height: 130px;\r\n  max-height: 130px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  background-image: url(/public/goose.webp);\r\n  background-position: right bottom;\r\n  background-repeat: no-repeat;\r\n  background-size: contain;\r\n  background-color: #1d1d1d;\r\n  font-weight: 400;\r\n  font-size: 14px;\r\n  color: rgb(207, 134, 255);\r\n  padding: 0.8rem;\r\n  border-top-left-radius: 20px;\r\n  border-top-right-radius: 20px;\r\n  /* box-shadow: inset 0px -5px 7px -1px rgba(0, 0, 0, 0.4),\r\n    inset 0px -12px 54px -7px rgba(0, 0, 0, 0.2),\r\n    inset 0px 25px 54px -7px rgba(0, 0, 0, 0.2),\r\n    inset 0px 25px 15px -1px rgba(238, 238, 238, 0.24); */\r\n}\r\n\r\n.debug-text {\r\n  max-width: 70%;\r\n  text-shadow: 0 0 5px #ebccff7e, 0 0 25px #ffffff83;\r\n  font-family: \"Press Start 2P\", system-ui;\r\n  line-height: 1rem;\r\n  text-align: center;\r\n  word-spacing: -0.4rem;\r\n}\r\n\r\n.control-panel {\r\n  width: 97vw;\r\n  height: 28vh;\r\n  max-width: 500px;\r\n  position: absolute;\r\n  bottom: 0;\r\n  align-items: center;\r\n  display: flex;\r\n  gap: 8px;\r\n  flex-direction: column;\r\n  justify-content: flex-end;\r\n  padding: 12px;\r\n  background-color: #1d1d1d;\r\n  border-radius: 20px;\r\n}\r\n\r\n.b-settings-container {\r\n  display: flex;\r\n  width: 100%;\r\n  height: 30%;\r\n  justify-content: space-between;\r\n  gap: 8px;\r\n}\r\n\r\n.b-settings {\r\n  font-family: \"Press Start 2P\", system-ui;\r\n  width: 80%;\r\n  height: 100%;\r\n  font-weight: 600;\r\n  overflow: hidden;\r\n  color: #a24ce9b7;\r\n  background-color: rgb(238, 238, 238);\r\n  box-shadow: inset 0px -10px 2px 0 rgba(44, 71, 160, 0.267);\r\n\r\n  border-radius: 8px;\r\n}\r\n\r\n.b-color-multiplyer {\r\n  color: rgba(162, 76, 233, 0.719);\r\n  background-color: rgb(238, 238, 238);\r\n  /* box-shadow: 0px 5px 5px 0 rgba(0, 0, 0, 0.2),\r\n    inset 0px -10px 2px 0 rgba(44, 71, 160, 0.267); */\r\n}\r\n\r\n.counters {\r\n  width: 100%;\r\n  height: 40%;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.counter-heading-text {\r\n  font-family: \"Press Start 2P\", system-ui;\r\n  font-size: 12px;\r\n  transform: translateY(2px);\r\n}\r\n.counter-container {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  display: flex;\r\n  padding: 0.3rem;\r\n  background: linear-gradient(\r\n    180deg,\r\n    rgb(192, 192, 192) 10%,\r\n    rgb(87, 87, 87) 95%,\r\n    rgb(61, 61, 61) 100%\r\n  );\r\n  border-radius: 8px;\r\n  width: 100%;\r\n  height: 50%;\r\n}\r\n\r\n.counter-heading {\r\n  background-color: rgb(178, 134, 219);\r\n  border-bottom: rgba(255, 255, 255, 0.404) 2px solid;\r\n  /* box-shadow: inset 0px 0px 12px 2px rgba(0, 0, 0, 0.4); */\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  color: rgba(3, 3, 3, 0.842);\r\n  padding: 0.3rem;\r\n  width: 30%;\r\n  height: 100%;\r\n  border-radius: 5px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin-right: 0.5rem;\r\n  white-space: nowrap;\r\n  transition: text 0.2s ease;\r\n}\r\n\r\n.counter-heading-have {\r\n  background-color: rgb(221, 170, 29);\r\n}\r\n\r\n.counter-text {\r\n  display: flex;\r\n  align-items: center;\r\n  width: 70%;\r\n  height: 100%;\r\n  background-color: rgb(49, 49, 49);\r\n  border-bottom: rgba(255, 255, 255, 0.404) 2px solid;\r\n  font-weight: 600;\r\n  color: rgb(227, 221, 230);\r\n  padding: 0.3rem 0.6rem;\r\n  border-radius: 5px;\r\n  /* box-shadow: inset 0px 6px 12px 2px rgba(0, 0, 0, 0.411); */\r\n}\r\n\r\n.b-roll {\r\n  font-family: \"Press Start 2P\", system-ui;\r\n  width: 100%;\r\n  height: 30%;\r\n  font-weight: 600;\r\n  overflow: hidden;\r\n  color: rgba(0, 0, 0, 0.719);\r\n  font-size: 18px;\r\n  border-radius: 8px;\r\n  background-color: #a771ff;\r\n  box-shadow: inset 0px -10px 2px 0 rgba(44, 71, 160, 0.267);\r\n}\r\n\r\n.b-combinations {\r\n  background-color: rgb(88, 88, 88);\r\n  height: 35px;\r\n  width: 35px;\r\n  font-size: 20px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  border-radius: 50%;\r\n  font-weight: 500;\r\n  color: black;\r\n  padding: 10px;\r\n  position: absolute;\r\n  right: 10px;\r\n}\r\n\r\n.bg-combs {\r\n  position: absolute;\r\n  z-index: 2;\r\n  bottom: 0;\r\n  left: 0;\r\n  display: flex;\r\n  justify-content: end;\r\n}\r\n\r\n.win-circle {\r\n  position: absolute;\r\n  z-index: 10;\r\n  width: 105%;\r\n  aspect-ratio: 1/1;\r\n  opacity: 0;\r\n  border-radius: 12px;\r\n  border: 5px solid #ffffff;\r\n  animation: showCircle 2s ease;\r\n}\r\n\r\n@keyframes showCircle {\r\n  0% {\r\n    opacity: 0;\r\n    scale: 1.5;\r\n  }\r\n  10% {\r\n    opacity: 1;\r\n    scale: 1;\r\n  }\r\n  90% {\r\n    opacity: 1;\r\n    scale: 1;\r\n  }\r\n  100% {\r\n    opacity: 0;\r\n    scale: 1.5;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
